"use client";

import { Box, Card, CardContent, Typography } from "@repo/ui";
import Image from "next/image";
import Section from "../components/Section";

type AboutAuthorProps = {
  sectionInfo: PageSections;
  data: {
    aboutAuthor: Author;
  };
};

type Author = {
  email: string;
  experience: string;
  expertise: string;
  image?: string;
  name: string;
  primary_contact: string;
  trainer_code: string;
};

const AboutAuthor = ({ sectionInfo, data }: AboutAuthorProps) => {
  return (
    <Section id={sectionInfo.id} className={sectionInfo.sectionClass}>
      <Card>
        <CardContent className="sm:gap-x-10 flex !p-8 items-center sm:!flex-row !flex-col gap-y-10">
          {data?.aboutAuthor?.image && (
            <Box>
              <Image
                src={data?.aboutAuthor?.image}
                width={227}
                height={250}
                alt={data?.aboutAuthor?.name}
                className="rounded-lg sm:aspect-[3/3.5] object-cover w-auto h-auto"
              />
            </Box>
          )}

          <Box className="flex-1">
            <Typography
              variant="h3"
              gutterBottom
              data-author-name={data?.aboutAuthor?.name}
            >
              {data?.aboutAuthor?.name}
            </Typography>
            <Typography paragraph className="text-gray-500">
              {data?.aboutAuthor?.experience}
            </Typography>
            <Typography paragraph className="text-gray-500">
              {data?.aboutAuthor?.expertise}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Section>
  );
};

export default AboutAuthor;
